import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { deleteAttachment } from 'bundles/apex/deals/show/store/deal/actions';
import {
  addTaskAttachment,
  createTask,
  deleteTask,
  deleteTaskAttachment,
  updateTask,
} from 'bundles/apex/deals/show/store/tasks/actions';
import { toggleTaskSelection } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

import CriticalDate from 'bundles/apex/deals/show/critical_dates/critical_date';
import Task from 'bundles/apex/tasks/task';

export const PlannerGroup = ({
  addTaskAttachment,
  attachmentsPath,
  checkImmediateRemindersPath,
  createTask,
  deal,
  deleteAttachment,
  deleteTask,
  deleteTaskAttachment,
  editing,
  features,
  fields,
  forUser,
  group,
  items,
  selection,
  toggleTaskSelection,
  updateTask,
  users
}) => {
  if (items.length === 0) {
    return null;
  }

  const deletePlannerAttachment = (task, attachment) => {
    deleteTaskAttachment(task, attachment);
    deleteAttachment(attachment);
  };

  return <React.Fragment>
    <tr className="planner-table-group-label">
      {editing && <td/>}
      <td className="pt-4 fs-large" colSpan="99">{group.label}</td>
    </tr>
    {items.map(({ name, record, type }) => {
      if (type === 'task') {
        return (
          <Task
            addTaskAttachment={addTaskAttachment}
            adminedOfficeIds={forUser.adminedOfficeIds}
            apexAdmin={forUser.apexAdmin}
            attachmentExceptions={features.taskAttachmentExceptions}
            attachmentsPath={attachmentsPath}
            canDeleteAttachments={forUser.canManageAllAttachments}
            checkImmediateRemindersPath={checkImmediateRemindersPath}
            deal={deal}
            deleteTaskAttachment={deletePlannerAttachment}
            edgeCrm={features.edgeCrm}
            editing={editing}
            fields={fields}
            key={record.id}
            requiredTasksEnabled={features.requiredTasks}
            selected={selection[record.id]}
            task={record}
            userId={forUser.id}
            users={users}
            onCreate={createTask}
            onDelete={deleteTask}
            onSelectionToggle={toggleTaskSelection}
            onUpdate={updateTask}
          />
        );
      } else {
        return (
          <CriticalDate
            criticalDate={record}
            dateName={name}
            deal={deal}
            editing={editing}
            fields={fields}
            key={name}
          />
        );
      }
    })}
  </React.Fragment>;
};

PlannerGroup.propTypes = {
  addTaskAttachment: PropTypes.func.isRequired,
  adminedOfficeIds: PropTypes.arrayOf(PropTypes.number),
  apexAdmin: PropTypes.bool,
  attachmentExceptions: PropTypes.bool,
  attachmentsPath: PropTypes.string,
  checkImmediateRemindersPath: PropTypes.string,
  createTask: PropTypes.func,
  deal: PropTypes.object,
  deleteAttachment: PropTypes.func.isRequired,
  deleteTask: PropTypes.func,
  deleteTaskAttachment: PropTypes.func.isRequired,
  editing: PropTypes.bool,
  features: PropTypes.shape({
    edgeCrm: PropTypes.bool,
    taskAttachmentExceptions: PropTypes.bool,
    requiredTasks: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.object,
  forUser: PropTypes.shape({
    canManageAllAttachments: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  group: PropTypes.shape({
    label: PropTypes.string.isRequired
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    record: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
  selection: PropTypes.object,
  toggleTaskSelection: PropTypes.func,
  updateTask: PropTypes.func,
  users: PropTypes.array,
};

const mapStateToProps = state => ({
  attachmentsPath: state.paths.attachments,
  checkImmediateRemindersPath: state.paths.checkUpdateForImmediateReminders,
  deal: state.deal,
  editing: state.plannerBulkActions.editing,
  features: state.features,
  fields: state.fields,
  forUser: state.forUser,
  selection: state.plannerBulkActions.selection,
  users: state.options.users,
});

const mapDispatchToProps = {
  addTaskAttachment,
  createTask,
  deleteAttachment,
  deleteTask,
  deleteTaskAttachment,
  toggleTaskSelection,
  updateTask,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlannerGroup);
